import styles from "./Player.module.scss"
import "video.js/dist/video-js.min.css"

import React, { useEffect, useRef, useState } from "react"

import { useAccount, useSchedule } from "@shared/contexts"
import { playerService } from "@shared/services"

import classNames from "classnames"
import videojs, { VideoJsPlayerOptions } from "video.js"
import { useSelectedVod, useSetVodPlayer, useVodPlayer } from "vod/contexts"

const VOD_SKIP_DECODE_ERROR_TIME = 0.5

export default function Player() {
  const { schedule } = useSchedule()
  const { account } = useAccount()
  const selectedVod = useSelectedVod()
  const vodPlayer = useVodPlayer()
  const setVodPlayer = useSetVodPlayer()

  const playerRef = useRef<HTMLVideoElement>(null)
  const [currentSecond, setCurrentSecond] = useState<number | null>()

  const src = selectedVod?.streamUrl
  const isUseNimble = schedule?.user.partner?.isUseNimble
  const isAnonymous = account.viewer?.role === "ANONYMOUS"

  useEffect(() => {
    if (!src || !playerRef.current || vodPlayer) return

    const options: VideoJsPlayerOptions = {
      autoplay: true,
      controls: true,
      preload: "auto",
      playbackRates: [0.5, 1, 1.25, 1.5, 1.75, 2],
      html5: {
        hls: {
          enableLowInitialPlaylist: true,
          smoothQualityChange: true,
          overrideNative: true,
        },
      },
    }

    setVodPlayer(videojs(playerRef.current, options))
  }, [src, playerRef, currentSecond, setVodPlayer, vodPlayer])

  useEffect(() => {
    if (!src || !vodPlayer) return

    if (!isUseNimble) return vodPlayer.src(src)
    ;(async () => {
      vodPlayer.src(
        await playerService.getStreamingUrl(src, "VOD", isAnonymous),
      )
    })()
  }, [src, vodPlayer, isUseNimble, isAnonymous])

  useEffect(() => {
    vodPlayer?.ready(() => {
      if (currentSecond) {
        vodPlayer.currentTime(currentSecond)
        setCurrentSecond(null)
      }
    })
  }, [vodPlayer, currentSecond])

  return (
    <article className={classNames("vodB", styles.vodWrap)}>
      <div data-vjs-player>
        <video
          className="vjs-matrix video-js"
          controls
          ref={playerRef}
          onError={(e) => {
            const element = e.target as HTMLMediaElement

            switch (element.error?.code) {
              case MediaError.MEDIA_ERR_DECODE:
                setCurrentSecond(
                  vodPlayer!.currentTime() + VOD_SKIP_DECODE_ERROR_TIME,
                )
                setVodPlayer(null)
                break
              default:
            }
          }}
        />
      </div>
    </article>
  )
}
